import { render, staticRenderFns } from "./OrdenesServicio.vue?vue&type=template&id=66e99620&"
import script from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
export * from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
import style0 from "./OrdenesServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports